import { Button, Form, Input, Space } from "antd";
import { useState } from "react";
import TickMark from "../../assets/icons/TickMark";
import AuthLayout from "../../layouts/AuthLayout";

export default function ForgotPassword() {
  const [withEmail, setWithEmail] = useState(true);

  return (
    <AuthLayout>
      <div className="text-[#3D4A5C] text-[22px] font-semibold">
        Enter your email address/Mobile number to reset password
      </div>

      <Space className="flex justify-center my-4">
        <Button
          className={`flex text-[#2D3643] gap-2 items-center ${
            withEmail ? "border-[#FE7235]" : "border-[#E9EFF6]"
          }`}
          onClick={() => setWithEmail(true)}
        >
          {withEmail ? <SelectedOption /> : <NotSelectedOption />}
          <div>Email</div>
        </Button>
        <Button
          className={`flex text-[#2D3643] gap-2 items-center ${
            !withEmail ? "border-[#FE7235]" : "border-[#E9EFF6]"
          }`}
          onClick={() => setWithEmail(false)}
        >
          {!withEmail ? <SelectedOption /> : <NotSelectedOption />}
          <div>Mobile</div>
        </Button>
      </Space>

      <Form name="login" initialValues={{ remember: true }} layout="vertical">
        {withEmail && (
          <Form.Item
            label=""
            name="email"
            rules={[{ required: true, message: "Please enter your email!" }]}
          >
            <Input placeholder="Enter your email" size="large" />
          </Form.Item>
        )}

        {!withEmail && (
          <Form.Item
            label=""
            name="mobile"
            rules={[{ required: true, message: "Please enter your email!" }]}
          >
            <Input prefix={"+880"} placeholder="ex: 172-354626" size="large" />
          </Form.Item>
        )}
      </Form>

      <Button type="primary" block>
        Send Verification Code
      </Button>
    </AuthLayout>
  );
}

const SelectedOption = () => {
  return (
    <div className="w-[20px] h-[20px] bg-[#FE7235] rounded-full flex items-center justify-center">
      <TickMark />
    </div>
  );
};

const NotSelectedOption = () => {
  return (
    <div className="w-[20px] h-[20px] bg-[#F9FAFB] border-[#AFBACA] rounded-full border"></div>
  );
};
